import { CommonModels } from './common.models';
import { PaymentModels } from './payment.models';
import { PolicyModels } from './policy.models';
import { TableModels } from './table.models';

export namespace RefundModels {
  export enum RefundTypeEnum {
    Resiliation = 1,
    Caducite = 2,
    Avenant = 3,
    FinDeGarantieProvisoire = 4,
    Autres = 5,
    Claim = 6,
  }

  export enum ClaimRefundBeneficiaryEnum {
    Garage = 1,
    Client = 2,
    Prestataire = 3,
    Autre = 4,
  }

  export interface RefundTableRow {
    receiptId: number;
    policy: PolicyInfos;
    refundType: RefundModels.RefundTypeEnum;
    payment: PaymentInfos;
    warning: WarningInfos;
    claimPublicId: number;
    isChecked: boolean;
    isDisabled: boolean;
  }

  export interface PaymentInfos {
    paymentMode: PaymentModels.PaymentModeEnum;
    daysElapsedSincePayment: number;
    amount: number;
    chequeNumber: number;
    paymentDate: Date;
    refundDate?: Date;
    refundValidatedDate?: Date;
    refundPlannedDate?: Date;
    beneficiary: BeneficiaryInfos;
  }

  export interface BeneficiaryInfos {
    type: number;
    firstName: string;
    lastName: string;
    address: BeneficiaryAddressInfos;
  }

  export interface BeneficiaryAddressInfos {
    addressLine1: string;
    addressLine2: string;
    city: string;
    zipCode: string;
  }

  export interface PolicyInfos {
    clientId: number;
    civility: CommonModels.CivilityEnum;
    firstName: string;
    lastName: string;
    iban: string;
    policyId: number;
    policyState: PolicyModels.PolicyStateEnum;
  }

  export interface WarningInfos {
    paymentDate: boolean;
    amount: boolean;
    iban: boolean;
  }

  export interface RefundsPaginatedRequest
    extends TableModels.PaginatedRequest {
    policyId?: number;
    refundType?: RefundModels.RefundTypeEnum;
    receiptState?: PolicyModels.ReceiptStateEnum;
    isOnlyEnabledRefunds?: boolean;
    paymentMode?: PaymentModels.PaymentModeEnum;
    isClaimRefund?: boolean;
  }

  export interface ReceiptList {
    ReceiptIds: number[];
  }

  export interface AddMiscRefund {
    amount?: number;
    startingDate?: Date;
    targetReceipt?: number;
  }

  export interface AddRefundChequeNumbersRequest {
    ChequeNumbers: ChequeNumberModel[];
  }

  export interface ChequeNumberModel {
    receiptId: number;
    chequeNumber: number;
  }
}
